import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

export const customerApiUserSchema = z.object({
  externalUsers: z.array(z.string()),
});
export type CustomerViewApiUserFormValues = z.infer<typeof customerApiUserSchema>;

export const useCustomerViewApiUserFormInitializer = ({ customerDetails }) => {
  const buildFormValues = (cd) => ({
    externalUsers: (cd?.externalUsers || []).map((externalUser) => externalUser._id),
  });

  const form = useForm<CustomerViewApiUserFormValues>({
    initialValues: buildFormValues(customerDetails),
    validate: zodResolver(customerApiUserSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
